/* import __COLOCATED_TEMPLATE__ from './sq-color-swatches.hbs.js'; */
var _dec, _dec2, _class, _class2;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@ember/component';
import { tagName } from '@ember-decorators/component';
import { assert } from '@ember/debug';
import { guidFor } from '@ember/object/internals';
import { computed } from '@ember/object';
let SqColorSwatches = (_dec = tagName(''), _dec2 = computed('colors', 'colorOptions'), _dec(_class = (_class2 = class SqColorSwatches extends Component {
  didReceiveAttrs() {
    super.didReceiveAttrs();
    assert('Exactly one of colors and color options should be passed in to sq-color-swatches', Boolean(this.colors) !== Boolean(this.colorOptions));
  }
  get swatchOptions() {
    return this.colorOptions || this.colors.map(color => ({
      color
    }));
  }
  get radioGroupName() {
    return `${guidFor(this)}-colors`;
  }
}, _applyDecoratedDescriptor(_class2.prototype, "swatchOptions", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "swatchOptions"), _class2.prototype), _class2)) || _class);
export { SqColorSwatches as default };